import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getWheelsWidthParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'wheelsWidthParts';

export const wheelsWidthPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearWheelsWidthParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getWheelsWidthParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearWheelsWidthParts } = wheelsWidthPartsSlice.actions;

export const wheelsWidthParts = wheelsWidthPartsSlice.reducer;
